export const LOCALE_OPTIONS = [
  { locale: "es", labelId: "spanish" },
  { locale: "ca", labelId: "catalan" },
  { locale: "en", labelId: "english" },
  { locale: "pt", labelId: "portuguese" },
  { locale: "de", labelId: "german" },
  { locale: "fr", labelId: "french" },
]

export const SUPPORTED_LOCALES = LOCALE_OPTIONS.map(({ locale }) => locale)

// El catalán no tiene código de país ISO propio: usamos la bandera regional
// de Cataluña (es-ct), ya que "ca" es el código de Canadá.
const FLAG_CODE_BY_LOCALE = {
  en: "gb",
  ca: "es-ct",
}

export const getCountryFlagCode = (locale) =>
  FLAG_CODE_BY_LOCALE[locale] || locale
